<template>
  <div class="user-chart-wrapper">
    <div class="chart-header">
      <h3>My Applications</h3>
      <select @change="computeChartData">
        <option value="thisMonth" selected>This Month</option>
        <option value="lastMonth">Last Month</option>
        <option value="twoMonths">Two months ago</option>
      </select>
    </div>
    <div class="user-chart">
      <line-chart
        v-if="loaded"
        :chartData="chartdata"
        :options="options"
        :styles="myStyles"
      />
    </div>
  </div>
</template>

<script>
import LineChart from './UserLineChart.js';

export default {
  name: 'LineChartContainer',
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: null,
    myApplications: null,
  }),
  computed: {
    myStyles() {
      return {
        position: 'relative',
        height: '400px',
        width: '100%',
      };
    },
  },
  async mounted() {
    this.loaded = false;
    try {
      await this.$store.dispatch('fetchUserData');

      this.myApplications = await this.$store.state.userData.myApplications;

      this.computeChartData({ target: { value: 'thisMonth' } });
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    computeChartData(e) {
      // ANAlYSIS OF MY APPLICATIONS
      let thisMonth = [];
      let lastMonth = [];
      let twoMonths = [];

      let thisMonthWeeks = {
        weekOne: 0,
        weekTwo: 0,
        weekThree: 0,
        weekFour: 0,
      };
      let lastMonthWeeks = {
        weekOne: 0,
        weekTwo: 0,
        weekThree: 0,
        weekFour: 0,
      };
      let twoMonthsWeeks = {
        weekOne: 0,
        weekTwo: 0,
        weekThree: 0,
        weekFour: 0,
      };

      this.myApplications.forEach((app) => {
        let toDateString = new Date(app.createdAt);
        let today = new Date(Date.now());

        if (toDateString.getMonth() === today.getMonth()) {
          // Analysis for This month goes here
          thisMonth.push(app);
          if (toDateString.getDate() <= 7) {
            thisMonthWeeks.weekOne = thisMonthWeeks.weekOne + 1;
          }
          if (toDateString.getDate() > 7 && toDateString.getDate() <= 14) {
            thisMonthWeeks.weekTwo = thisMonthWeeks.weekTwo + 1;
          }
          if (toDateString.getDate() > 14 && toDateString.getDate() <= 21) {
            thisMonthWeeks.weekThree = thisMonthWeeks.weekThree + 1;
          }
          if (toDateString.getDate() > 21) {
            thisMonthWeeks.weekFour = thisMonthWeeks.weekFour + 1;
          }
        } else if (toDateString.getMonth() === today.getMonth() - 1) {
          // Analysis for last month goes here
          lastMonth.push(app);
          if (toDateString.getDate() <= 7) {
            lastMonthWeeks.weekOne = lastMonthWeeks.weekOne + 1;
          }
          if (toDateString.getDate() > 7 && toDateString.getDate() <= 14) {
            lastMonthWeeks.weekTwo = lastMonthWeeks.weekTwo + 1;
          }
          if (toDateString.getDate() > 14 && toDateString.getDate() <= 21) {
            lastMonthWeeks.weekThree = lastMonthWeeks.weekThree + 1;
          }
          if (toDateString.getDate() > 21) {
            lastMonthWeeks.weekFour = lastMonthWeeks.weekFour + 1;
          }
        } else if (toDateString.getMonth() === today.getMonth() - 2) {
          // Analysis for two months goes here
          twoMonths.push(app);
          if (toDateString.getDate() <= 7) {
            twoMonthsWeeks.weekOne = twoMonthsWeeks.weekOne + 1;
          }
          if (toDateString.getDate() > 7 && toDateString.getDate() <= 14) {
            twoMonthsWeeks.weekTwo = twoMonthsWeeks.weekTwo + 1;
          }
          if (toDateString.getDate() > 14 && toDateString.getDate() <= 21) {
            twoMonthsWeeks.weekThree = twoMonthsWeeks.weekThree + 1;
          }
          if (toDateString.getDate() > 21) {
            twoMonthsWeeks.weekFour = twoMonthsWeeks.weekFour + 1;
          }
        }
      });
      this.chartdata = {
        labels: ['Week 01', 'Week 02', 'Week 03', 'Week 04'],
        datasets: [
          {
            label: 'Applications Per Week',
            data: [],
            backgroundColor: 'rgba(26, 107, 158, 0.3)',
            borderColor: '#2B3D6E',
            borderWidth: 1,
          },
        ],
      };

      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        lineTension: 1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: false,
                padding: 25,
              },
            },
          ],
        },
      };
      if (e.target.value === 'lastMonth') {
        this.loaded = false;
        this.chartdata.datasets[0].data.push(
          lastMonthWeeks.weekOne,
          lastMonthWeeks.weekTwo,
          lastMonthWeeks.weekThree,
          lastMonthWeeks.weekFour
        );
        this.loaded = true;
        return this.chartdata;

      } else if (e.target.value === 'twoMonths') {
        this.loaded = false;
        this.chartdata.datasets[0].data.push(
          twoMonthsWeeks.weekOne,
          twoMonthsWeeks.weekTwo,
          twoMonthsWeeks.weekThree,
          twoMonthsWeeks.weekFour
        );

        this.loaded = true;
      } else if (e.target.value === 'thisMonth') {
        this.loaded = false;
        this.chartdata.datasets[0].data.push(
          thisMonthWeeks.weekOne,
          thisMonthWeeks.weekTwo,
          thisMonthWeeks.weekThree,
          thisMonthWeeks.weekFour
        );

        this.loaded = true;
      }
    },
  },
};
</script>
<style scoped>
  .user-chart-wrapper {
    min-height: 300px;
    padding: 1.3rem;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 15px;
    background: var(--white);
  }
  .chart-header {
    display: flex;
    text-align: center;
    justify-content: space-between;
    margin-right: 18px;
    margin-bottom: 85px;
  }
  .chart-header h3 {
    font-family: "montserrat";
    font-weight: 600;
    size: 20px;
    line-height: 24.38px;
    color:#071a52;
  }
  select {
    background: var(--white);
    border: 3px solid #071a52;
    border-radius: 20px;
    font-size: 11px;
    text-align: center;
    color: var(--colorSecondary);
    padding: 10px 12px;
    outline: none;
  }

  @media only screen and (max-width: 380px) {
    .chart-header {
      flex-direction: column;
      padding: 0.5rem 0.75rem !important;
      gap: 1rem;
    }
  }
</style>
